module.exports = __webpack_public_path__ + "static/media/home.39caefe8.jpg";